import { computed, ref, type ComputedRef, type Ref } from 'vue';

export interface Pagination {
  perPage: Ref<number>;
  page: Ref<number>;
  count: Ref<number>;
  totalPages: ComputedRef<number>;
  setPage(p: number): void;
  setCount(c: number): void;
}

const DEFAULT_PER_PAGE = 11;

export function usePagination(initialPerPage = DEFAULT_PER_PAGE): Pagination {
  const perPage = ref(initialPerPage);
  const page = ref(1);
  const count = ref(1);

  return {
    perPage,
    page,
    count,
    totalPages: computed(() => Math.max(1, Math.ceil(count.value / perPage.value))),
    setPage(p) {
      page.value = p;
    },
    setCount(c) {
      count.value = c;
    },
  };
}
